import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-20",
  "use": "icon-sheet_icon-20-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-20\"><g transform=\"translate(1 1)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><rect x=\".75\" y=\"9.75\" width=\"4.5\" height=\"9.5\" rx=\"1\" /><path d=\"M13 4.75L13.25 19 9 19.25 8.75 5 13 4.75z\" /><rect x=\"16.75\" y=\".75\" width=\"4.5\" height=\"18.5\" rx=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol